import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./index.css";

const ThankYouPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Thank You Submitting The Form | Affordable Trash Collection Service
          for Apartment Communities
        </title>
        <meta
          name="description"
          content="Affordable trash collection services designed for apartment complexes in Peoria, IL. Quality, convenience, and cost-effective solutions you can trust!"
        />
        <link
          rel="canonical"
          href="https://simpletrashsolutionsllc.com/thank-you"
        />
      </Helmet>
      <div className="thank-you-container">
        <div className="thank-you-content">
          <h1>Thanks for Submitting the Form!</h1>
          <p>
            Your message has been received. We appreciate you reaching out to us
            and will get back to you as soon as possible.
          </p>
          <Link to="/" className="link-name">
            <button className="home-button">Back To Home</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ThankYouPage;
